import React, { useEffect, useState } from 'react';
import { Button, Card, Col, DatePicker, Divider, Form, Input, InputNumber, Modal, Row, Select, Space, Table, Tag, Tooltip, message, notification } from 'antd';
import { DeleteFilled, EditOutlined, ExportOutlined, EyeOutlined, PlusCircleOutlined, SyncOutlined, ToTopOutlined } from '@ant-design/icons';
import { ExerciceDocService } from '../Services/ExerciceDocService';
import { TraitementService } from '../Services/TraitementService';
import dayjs from "dayjs"
import "../Pages/CSS/Traitement.css";

import { ArticlesAchatService } from '../Services/ArticlesAchatService';
import TotalList from './TotalList';
import * as XLSX from "xlsx";
import moment from 'moment';
const { confirm } = Modal
const { Option } = Select;
const TraiteFournDiv = () => {
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [loading, setLoading] = useState([]);
  const [refreshTable, setRefreshTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [fournisData, setFournisData] = useState([]);
  const [articlesData, setArticlesData] = useState([]);
  const [addedRows, setAddedRows] = useState([]);
  const [selectedOption, setSelectedOption] = useState("R");
  const [modalTitle, setModalTitle] = useState("");
  const [modalTitle1, setModalTitle1] = useState("");
  const [editingRecord, setEditingRecord] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);

  const [isEditMode, setIsEditMode] = useState(false);
  const [montantNet, setMontantNet] = useState(0);
  const [montantTTC, setMontantTTC] = useState(0);
  const [totalHT, setTotalHT] = useState(0);
  const [totalRemise, setTotalRemise] = useState(0);
  const [totalTVA, setTotalTVA] = useState(0);
  const [totalTTC, setTotalTTC] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible1, setIsModalVisible1] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [years, setYears] = useState([]);
  const [form] = Form.useForm();

  const traitementsoinsService = new TraitementService();
  const articleachatService = new ArticlesAchatService();
  const exerciceDocService = new ExerciceDocService();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getFactureExercicesDoc();
        setYears(yearsData);
        await fetchDataByOption(selectedOption);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [selectedOption]);

  useEffect(() => {
    fetchDataByOption(selectedOption);
  }, [selectedYear, selectedOption, refreshTable]);


  const fetchDataByOption = async (option) => {
    setLoading(true);
    try {
      let data;
      let shouldShowAdditionalColumns = false;

      switch (option) {
        case "A":
          data = await traitementsoinsService.getAllDivers(selectedYear);
          shouldShowAdditionalColumns = true;
          break;
        case "R":
          data = await traitementsoinsService.getReçueDivers(selectedYear);
          break;
        case "T":
          data = await traitementsoinsService.getTraiteDivers(selectedYear);
          break;
        case "C":
          data = await traitementsoinsService.getComptaDivers(selectedYear);
          break;
        case "P":
          data = await traitementsoinsService.getPayeDivers(selectedYear);
          break;
        default:
          break;
      }

      setTableData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const handleSelectChange = (value) => {
    setSelectedOption(value);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };

  const fetchFournis = async () => {
    try {
      const fournisseurs = await traitementsoinsService.getPlanComptafourn();
      setFournisData(fournisseurs);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };
  const fetchAchats = async () => {
    try {
      const achats = await articleachatService.getAllArticlesAchat();
      setArticlesData(achats);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };
  const handleArticleSelect = (value) => {
    const selectedArticle = articlesData.find(
      (article) => article.code_art === value
    );
    if (selectedArticle) {
      form.setFieldsValue({
        prix_unitaire: selectedArticle.prix_unitaire,
      });
    }
  };

  const handleRefresh = () => {
    setRefreshTable(!refreshTable);
  };

  const handleOpen = (record = null) => {
    if (record) {
      const convertedRecord = {
        ...record,
        datefact: record.datefact ? dayjs(record.datefact) : null,
        daterecep: record.daterecep ? dayjs(record.daterecep) : null,
      };
      form.setFieldsValue(convertedRecord);
      setMontantTTC(convertedRecord.montfact || 0); // Set montantTTC to the value of montfact
      setMontantNet(convertedRecord.montfact || 0);
      setEditingRecord(record);
      setModalTitle(`Modifier la facture N° ${record.numenreg}`);
      setIsEditMode(true);
    } else {
      form.resetFields();
      setMontantTTC(0); // Reset montantTTC to 0
      setMontantNet(0)
      setModalTitle("Créer une facture");
      setIsEditMode(false);
    }
    fetchFournis();
    setIsModalVisible(true);
  };


  const onEdit = (record) => {
    handleOpen(record);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();


  };
  const handleOpenModal = (record = null) => {
    if (record) {
      const convertedRecord = {
        ...record,
        datefact: record.datefact ? dayjs(record.datefact) : null,
        daterecep: record.daterecep ? dayjs(record.daterecep) : null,
      };
      form.setFieldsValue(convertedRecord);
      console.log(convertedRecord);
      setModalTitle1(`Traitement Facture N° ${record.numenreg}`);
      setEditingRecord(record);

      // Récupérer le fournisseur correspondant
      const numfourn = record.numfourn;
      const fournisseur = fournisData.find(fournis => fournis.compte === numfourn);
      if (fournisseur) {
        form.setFieldsValue({ numfourn: fournisseur.compte });
      }

      fetchAchats();
      setIsModalVisible1(true);
    }
  };

  useEffect(() => {
    fetchFournis();
  }, []);

  const handleCloseModal = () => {
    setIsModalVisible1(false);
    form.resetFields();
    setTotalHT(0);
    setTotalRemise(0);
    setTotalTVA(0);
    setTotalTTC(0);
    setAddedRows([])
  };

  const handleMontantChange = (value) => {
    setMontantTTC(value)
    setMontantNet(value);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        const fournisseur = fournisData.find(fournis => fournis.compte === values.numfourn);
        const raisoc = fournisseur ? fournisseur.intitule : '';

        const docData = {
          ...values,
          avoir: "",
          raisoc,
          mont_prepaid: 0,
          numenreg: editingRecord ? editingRecord.numenreg : null,
          prepaid: false,
          qp_agent: 0,
          rembourse: "non",
          remise: 0,
          ristourne: 0,
          typefact: "D",
          typeremb: "",
          datefact: values.datefact ? values.datefact.format("YYYY-MM-DD") : null,
          daterecep: values.daterecep ? values.daterecep.format("YYYY-MM-DD") : null,
        };

        try {
          if (isEditMode) {
            await traitementsoinsService.EditFacture(editingRecord.numenreg, docData);
            message.success("Facture mise à jour avec succès!");
          } else {
            await traitementsoinsService.AddFacture(docData);
            message.success("Facture créée avec succès!");
          }
          form.resetFields();
          setIsModalVisible(false);
          fetchDataByOption(selectedOption);
        } catch (error) {
          console.error('Erreur lors de la soumission de la facture:', error);
          message.error("La soumission de la facture a échoué.");
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
        message.error("La validation du formulaire a échoué.");
      });
  };


  const handleDeleteline = async (numenreg) => {
    try {
      confirm({
        title: `Êtes-vous sûr de vouloir supprimer la facture N° ${numenreg} ?`,
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await traitementsoinsService.deleteFacture(numenreg);
            const updatedData = filteredData.filter(
              (item) => item.numenreg !== numenreg
            );
            setFilteredData(updatedData);
            fetchDataByOption(selectedOption);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel() {
          // Annulation
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };
  const calculateTotals = (rows) => {
    let totalHT = 0;
    let totalRemise = 0;
    let totalTVA = 0;
    let totalTTC = 0;

    rows.forEach((row) => {
      totalHT += row.m_ht;
      totalRemise += row.m_remise;
      totalTVA += row.m_tva;
      totalTTC += row.m_ttc;
    });

    return { totalHT, totalRemise, totalTVA, totalTTC };
  };

  const handleAddRow = () => {
    const values = form.getFieldsValue();
    const selectedArticle = articlesData.find((article) => article.code_art === values.code_art);
    const selectedTva = { label: `${values.tva}%`, value: values.tva }; // Inclure le label et la valeur de la TVA

    if (selectedArticle && values.qte && values.remise !== undefined && values.tva !== undefined && values.prix_unitaire !== undefined) {
      const m_ht = values.qte * values.prix_unitaire;
      const m_htRemise = m_ht - (m_ht * values.remise) / 100;
      const m_tva = (m_htRemise * values.tva) / 100;
      const m_ttc = m_htRemise + m_tva;

      const newRow = {
        code_art: selectedArticle.code_art,
        designation_article: selectedArticle.designation_article,
        qte: values.qte,
        prix_unitaire: values.prix_unitaire,
        m_remise: (m_ht * values.remise) / 100,
        m_ht: m_htRemise,
        tva: selectedTva, // Ajoutez l'objet TVA ici
        m_tva: m_tva,
        m_ttc: m_ttc,
      };

      const existingRow = addedRows.find(row => row.code_art === newRow.code_art);
      if (existingRow) {
        notification.warning({
          message: "Duplication",
          description: "Cet article a déjà été ajouté à la table.",
        });
        return;
      }

      const updatedRows = [...addedRows, newRow];
      const { totalHT, totalRemise, totalTVA, totalTTC } = calculateTotals(updatedRows);

      setAddedRows(updatedRows);
      setTotalHT(totalHT);
      setTotalRemise(totalRemise);
      setTotalTVA(totalTVA);
      setTotalTTC(totalTTC);

      form.resetFields(["code_art", "qte", "remise", "tva", "prix_unitaire"]);
    } else {
      message.error("Veuillez remplir tous les champs requis.");
    }
  };



  const handleSave = async () => {
    try {
      const values = form.getFieldsValue();
      const numfourn = editingRecord.numfourn;
      const montantFacture = editingRecord.montfact;
      console.log('numfourn:', numfourn);
      console.log('fournisData:', fournisData);

      const fournisseur = fournisData.find(
        (fournis) => fournis.compte === numfourn
      );

      if (!fournisseur) {
        message.error("Fournisseur non trouvé!");
        return;
      }

      const calculatedTotalTTC = addedRows.reduce((total, row) => total + row.m_ttc, 0);

      if (montantFacture !== calculatedTotalTTC) {

        notification.warning({
          message: "Alerte",
          description: "Le montant de la facture doit être égal au montant TTC calculé.",
        });
        return;
      }

      const docData = {
        Fournisseur: fournisseur,
        num_offre: editingRecord ? editingRecord.numenreg : null,
        numfourn: numfourn,
        user_id: "dev1", // Vous pouvez changer cela selon votre logique
        date_ba: values.date_ba,
        listArticles: addedRows.map(row => ({
          ...row,
          Article: articlesData.find(
            (article) => article.code_art === row.code_art
          ),
        })),
        perim: "IPM", // Vous pouvez ajuster cela selon vos besoins
      };

      await traitementsoinsService.UpdateFacture(docData);
      message.success("Facture mise à jour avec succès!");
      form.resetFields();
      setIsModalVisible1(false);
      fetchDataByOption(selectedOption);
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la facture:', error);
      message.error("La mise à jour de la facture a échoué.");
    }
  };

  const handleRegenerate = async (record) => {
    // `record` contient toutes les données de la ligne que tu veux régénérer
    const numenreg = record.numenreg;

    try {
      const response = await traitementsoinsService.RegenereFactureDiv(numenreg, record);
      message.success('La facture a été régénérée avec succès!');
      // Met à jour les données dans ton interface utilisateur ici, si nécessaire
      fetchDataByOption(selectedOption); // Rafraîchir les données affichées si nécessaire
    } catch (error) {
      message.error('Erreur lors de la régénération de la facture.');
      console.error('Erreur lors de la régénération de la facture :', error);
    }
  };

  const handleDeleteRow = (codeArt) => {
    const updatedRows = addedRows.filter(row => row.code_art !== codeArt);
    const { totalHT, totalRemise, totalTVA, totalTTC } = calculateTotals(updatedRows);

    setAddedRows(updatedRows);
    setTotalHT(totalHT);
    setTotalRemise(totalRemise);
    setTotalTVA(totalTVA);
    setTotalTTC(totalTTC);
  };


  const handleCompta = () => {
    // Ajoutez ici le code pour gérer la comptabilisation
    console.log("Comptabiliser les lignes sélectionnées:", selectedRowKeys);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("Selected row keys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = selectedOption === 'T' ? {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      console.log("Selected row keys changed: ", newSelectedRowKeys);
      setSelectedRowKeys(newSelectedRowKeys);
    },
  } : null;


  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }

  const columns = [
    { title: 'N°', dataIndex: 'numenreg', key: 'numenreg' },
    { title: 'N° facture Frs', dataIndex: 'numfact', key: 'numfact', align: 'center' },
    { title: 'Date facture', dataIndex: 'datefact', key: 'datefact' },
    { title: 'Reçu le', dataIndex: 'daterecep', key: 'daterecep', align: 'center' },
    { title: 'Saisie le', dataIndex: 'datesaisie', key: 'datesaisie' },
    { title: 'Traitée le', dataIndex: 'traiteLe', key: 'traiteLe' },
    { title: 'Date compta', dataIndex: 'dateCompta', key: 'dateCompta' },
    { title: 'Echéance', dataIndex: 'echeance', key: 'echeance' },
    { title: 'Payée le', dataIndex: 'payeeLe', key: 'payeeLe' },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",


          }}
        >
          Montant.
        </div>
      ),
      dataIndex: "montfact", key: "montfact", align: 'right',
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    { title: 'N° Frs', dataIndex: 'numfourn', key: 'numfourn' },
    { title: 'Fournisseur', dataIndex: 'raisoc', key: 'raisoc' },
    { title: 'Spécialité', dataIndex: 'specialite', key: 'specialite' },
    { title: 'Société', dataIndex: 'societe', key: 'societe' },
    { title: 'Saisie par', dataIndex: 'saisiePar', key: 'saisiePar' },
    { title: 'Traitée par', dataIndex: 'traitePar', key: 'traitePar' },
    { title: 'Comptabilisée par', dataIndex: 'comptabiliseePar', key: 'comptabiliseePar' },
    {
      title: 'Etat', dataIndex: 'etat', key: 'etat', align: 'center',
      render: (text) => {
        let tagColor, tagText;
        switch (text) {
          case "R":
            tagColor = " #46de04";
            tagText = "reçue";
            break;
          case "C":
            tagColor = "#f2b305";
            tagText = "Comptabilisée";
            break;
          case "T":
            tagColor = "#fa0202";
            tagText = "traitée";
            break;
          case "P":
            tagColor = "#1890ff";
            tagText = "Payée";
            break;
          default:
            tagColor = "gray";
            tagText = "Inconnu";
        }

        return <Tag color={tagColor}>{tagText}</Tag>;
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",

          }}
        ></div>
      ),
      className: "small-cell",
      ellipsis: true,
      dataIndex: "actions",
      key: "actions",
      align: "center",

      width: 50, // Ajustez la largeur selon vos besoins
      render: (text, record) => (
        <span>
          {selectedOption === 'A' || selectedOption === 'C' ? (
            <Tooltip title="traitement facture">
              <EyeOutlined style={{ cursor: "pointer", color: "green", marginRight: 8 }} onClick={() => handleOpenModal(record)} />
            </Tooltip>
          ) : record.etat === 'T' ? (
            <>
              <Tooltip title="traitement facture">
                <EyeOutlined style={{ cursor: "pointer", color: "green", marginRight: 8 }} onClick={() => handleOpenModal(record)} />
              </Tooltip>
              <Tooltip title="Régénérer">
                <ToTopOutlined style={{ cursor: "pointer", color: "#f7b602" }} onClick={() => handleRegenerate(record)} />
              </Tooltip>
            </>
          ) : (
            <>
              <Tooltip title="traitement facture">
                <EyeOutlined style={{ cursor: "pointer", color: "green", marginRight: 8 }} onClick={() => handleOpenModal(record)} />
              </Tooltip>
              <Tooltip title="Modifier">
                <EditOutlined
                  style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
                  onClick={() => onEdit(record)}
                />
              </Tooltip>
              <Tooltip title="Supprimer">
                <DeleteFilled style={{ cursor: "pointer", color: "red" }} onClick={() => handleDeleteline(record.numenreg)} />
              </Tooltip>
            </>
          )}
        </span>
      ),
    }
  ];

  const columns1 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
    },
    {
      title: "Matricule",
      dataIndex: "matri",
      key: "matri",
      align: "center",
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
  ];

  const handleComptabiliser = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );
      console.log(...selectedRows);
      const data = await traitementsoinsService.addPreviewCompta1(selectedRows);
      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };

  const handleValidCompta = async () => {
    try {
      const selectedRows = tableData.filter((row) =>
        selectedRowKeys.includes(row.numenreg)
      );
      const payload = {
        comptas: comptaPreviewData,
        factures: selectedRows,
      };
      const data = await traitementsoinsService.addValidCompta1(payload);
      setRefreshTable(!refreshTable);
      setIsModalOpen(false);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };
  const exportToExcel = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };

  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  return (
    <div>
      <Card>
        <Row gutter={16} justify="space-between"
          align="middle" style={{ marginBottom: "16px" }}>
          <Col
            xs={24} sm={24} md={12} lg={12} xl={12}
            style={{
              textAlign: "right",
              display: "flex",
              justifyContent: "start",
            }}
          >
            <Space wrap>
              <Space direction="vertical" style={{ textAlign: "left" }}>
                <label style={{ fontSize: 12 }}>Exercice</label>
                <Select bordered={false} style={{ marginRight: 10, borderBottom: "2px solid #030303" }}
                  onChange={handleYearChange}
                  value={selectedYear}
                >
                  {years.map((year) => (
                    <Option key={year} value={year}>
                      {year}
                    </Option>
                  ))}
                </Select>
              </Space>
              <Space direction="vertical" style={{ textAlign: "left" }}>
                <label style={{ fontSize: 12 }}>Etat</label>
                <Select bordered={false} style={{ width: 160, marginRight: 10, borderBottom: "2px solid #030303", }}
                  onChange={handleSelectChange}
                  value={selectedOption}
                >
                  <Option value="A">Toutes</Option>
                  <Option value="R">REÇUE</Option>
                  <Option value="T">TRAITÉES</Option>
                  <Option value="C">COMPTABILISÉES</Option>
                  <Option value="P">PAYÉE</Option>
                </Select>
              </Space>
              <Input
                placeholder="Rechercher..."
                bordered={false}
                style={{ marginTop: "25px", borderBottom: "2px solid #030303" }}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Space>
          </Col>
          <Col
            xs={24} sm={24} md={12} lg={12} xl={12}
            style={{ display: "flex", justifyContent: "flex-end" }} >
            <Space wrap>
              <Button className="buttonRecep" icon={<PlusCircleOutlined />} onClick={() => handleOpen()}>
                Receptionner une facture
              </Button>
              <Button
                className="buttonCompta"
                icon={<ExportOutlined />}
                onClick={handleComptabiliser}
                disabled={selectedOption !== 'T' || selectedRowKeys.length === 0}
              >
                Comptabiliser
              </Button>
              <Button className="buttonExport" icon={<ExportOutlined />} >
                Export
              </Button>
              <Button
                className="buttonRefresh"
                icon={<SyncOutlined />}
                onClick={handleRefresh}
              ></Button>
            </Space>
          </Col>
        </Row>

        <Table
          rowSelection={rowSelection}
          rowKey="numenreg"
          scroll={{
            x: true,
          }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header2-table my-custom-table"
          // permet aussi de maintenir la couleur de la ligne
          rowClassName={(record) =>
            selectedRowKeys.includes(record.numenreg) ? "selected-row" : ""
          }
          bordered
          loading={loading}
          showSorterTooltip={false}
          dataSource={filteredData}
          columns={columns}
          pagination={{
            pageSize: 15, // le nombre d'éléments par page
          }} />
      </Card>

      <Modal
        title={modalTitle}
        open={isModalVisible}
        onCancel={handleCancel}
        maskClosable={false}

        style={{
          top: 20,
        }}
        footer={[
          <Button key="back" onClick={handleCancel} >
            Annuler
          </Button>,
          <Button key="submit" onClick={handleSubmit} className="Buttonvalid">
            {isEditMode ? "Modifier" : "Créer"}
          </Button>,
        ]}
        width={800} >
        <Form form={form} layout='vertical'>
          <Col span={24}>
            <Divider orientation="left">
              Informations du fournisseur
            </Divider>
            <Row gutter={16}>
              <Col span={13}>
                <Form.Item
                  label="Fournisseur"
                  name="numfourn"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un type de document!",
                    },
                  ]}
                >
                  <Select
                    placeholder="-- Sélectionnez --"
                    style={{ width: "100%" }}>
                    {fournisData.map((fournis) => (
                      <Option key={fournis.compte} value={fournis.compte}>
                        {`${fournis.compte} - ${fournis.intitule}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

            </Row>

            <Divider orientation="left">
              Entête facture
            </Divider>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="N° facture"
                  name="numfact"
                  rules={[{ required: true, message: "Ce champ est obligatoire!" }]}
                >
                  <Input
                    style={{ width: "100%" }} />

                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Date Facture"
                  name="datefact"
                  rules={[{ required: true, message: "Ce champ est obligatoire!" }]}
                >
                  <DatePicker disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  } format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="Date Reçu"
                  name="daterecep"
                  initialValue={dayjs(moment())}
                  rules={[{ required: true, message: "Ce champ est obligatoire!" }]}
                >
                  <DatePicker disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  } format="DD/MM/YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label={`Montant TTC (${montantTTC})`}
                  name="montfact"
                  rules={[{ required: true, message: "Ce champ est obligatoire!" }]}
                >
                  <InputNumber style={{ width: "100%" }} onChange={handleMontantChange} />
                </Form.Item>
              </Col>
            </Row>
            <div style={{ textAlign: "right" }}>Montant Net Facture: {montantNet}</div>
          </Col>
        </Form>
      </Modal>

      <Modal
        title={modalTitle1}
        open={isModalVisible1}
        onCancel={handleCloseModal}
        maskClosable={false}
        footer={null}
        style={{ top: 20 }}
        width={1000}>
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSave}
          initialValues={{
            qte: 1,
            remise: 0,
            tva: 18,
            statut: "En cours",
            remarque: "",
            adresse_liv: "",
          }}
        >
          <Row gutter={16} style={{ display: "flex", justifyContent: "space-between" }}>
            <Col span={12}>
              <p><strong>Fournisseur:</strong> {editingRecord ? editingRecord.raisoc : null}</p>
              <p><strong> N° Facture :</strong> {editingRecord ? editingRecord.numfact : null} <strong>- Date :</strong> {editingRecord ? editingRecord.datefact : null}</p>
              <p><strong>Montant Facture : </strong>{editingRecord ? editingRecord.montfact : null}</p>
            </Col>
            <Col span={12}></Col>
          </Row>
          <Row gutter={16} style={{ backgroundColor: "ButtonShadow", marginBottom: "18px" }}>
            <Col span={8}>
              <Form.Item label="Article" name="code_art" >
                <Select
                  style={{ width: "100%" }}
                  defaultValue={"--Selectionner--"}
                  onChange={handleArticleSelect}
                >
                  {articlesData.map((article) => (
                    <Option key={article.code_art} value={article.code_art}>
                      {`${article.designation_article}`}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item label="Quantité" name="qte" rules={[{ required: true, message: "Champ requis" }]} initialValues={0}>
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="P.Unitaire (0)" name="prix_unitaire" >
                <Input />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item label="TVA (%)" name="tva" rules={[{ required: true, message: "Champ requis" }]} initialValues={18}>
                <Select style={{ width: "100%" }}>
                  <Option value={0}>0%</Option>
                  <Option value={18}>18%</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Form.Item label="Remise (%)" name="remise" rules={[{ required: true, message: "Champ requis" }]} initialValues={0}>
                <InputNumber style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <div style={{ marginTop: "30px" }}>
              <Button onClick={handleAddRow} style={{ backgroundColor: "green" }}>
                Valider
              </Button>
            </div>
          </Row>
          <Table
            style={{
              cursor: "pointer",
              whiteSpace: "nowrap",
              width: "100%",
              marginBottom: "18px",
            }}
            className="custom-header1-table"
            bordered
            scroll={{ x: true }}
            dataSource={addedRows}
            columns={[
              {
                title: "Code Art.",
                dataIndex: "code_art",
                key: "code_art",
                align: "center",
              },
              {
                title: "Description",
                dataIndex: "designation_article",
                key: "designation_article",
              },
              {
                title: "Qte",
                dataIndex: "qte",
                key: "qte",
                align: "center",
              },
              {
                title: "P. unitaire",
                dataIndex: "prix_unitaire",
                key: "prix_unitaire",
                align: "right",
              },
              {
                title: "Remise",
                dataIndex: "m_remise",
                key: "m_remise",
                align: "right",
              },
              {
                title: "Montant HT",
                dataIndex: "m_ht",
                key: "m_ht",
                align: "right",
              },
              {
                title: "TVA",
                dataIndex: "tva",
                key: "tva",
                align: "center",
                render: (tva) => tva.label, // Affichez le label de la TVA
              },
              {
                title: "Montant TTC",
                dataIndex: "m_ttc",
                key: "m_ttc",
                align: "right",
              },
              {
                title: "Actions",
                key: "actions",
                align: "center",
                render: (text, record) => (
                  <span>
                    <Tooltip title="Supprimer">
                      <DeleteFilled
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() => handleDeleteRow(record.code_art)}
                      />
                    </Tooltip>
                  </span>
                ),
              },
            ]}
          />
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="date_ba" label="Date Comptable" initialValue={dayjs(moment())}>
                <DatePicker
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                  format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <TotalList
                totalHT={totalHT}
                totalRemise={totalRemise}
                totalTVA={totalTVA}
                totalTTC={totalTTC}
              />
            </Col>
          </Row>
          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Form.Item>
              <Button onClick={handleCloseModal} type="dashed" danger>
                Annuler
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                style={{ backgroundColor: "#010f1c", marginLeft: 8 }}
              >
                Enregistrer
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
      <Modal
        title="Aperçu écritures au journal"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel(
                prepareDataForExport(comptaPreviewData),
                "AperçuEcritureJournalExport.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button className="Buttonvalid" disabled={solde1 !== 0} onClick={handleValidCompta}>
            Valider
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
            y: 240
          }}

          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns1}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Débit : {formatNumber(totalDebit1)}</strong>
                <strong>Total Crédit : {formatNumber(totalCredit1)}</strong>
                <strong> Solde : {formatNumber(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </Modal>

    </div>
  );
}

export default TraiteFournDiv